import React from 'react';

export const SearchIcon = props => (
  <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.24963273 1.05C4.25467898 1.05 1 4.30465261 1 8.29963525 1 12.2946029 4.25467398 15.549278 8.24963273 15.549278c1.72778446 0 3.31482897-.610775 4.56226857-1.6249251l4.9060035 4.9060002c.2928524.29285.7695747.292875 1.0624446 0 .2928675-.292875.2928675-.761775 0-1.054625l-4.9060009-4.9060002c1.0161972-1.248075 1.624917-2.84037509 1.624917-4.57009265C15.4992655 4.30465261 12.244589 1.05 8.24963273 1.05zm0 1.49992505c3.18433147 0 5.74970817 2.56535509 5.74970817 5.7497102 0 3.18431765-2.5653817 5.74971775-5.74970817 5.74971775-3.1843265 0-5.7497082-2.5654001-5.7497082-5.74971775 0-3.18435511 2.5653767-5.7497102 5.7497082-5.7497102z"
      fill="#647A85"
      fillRule="nonzero"
      stroke="#667485"
      strokeWidth=".5"
    />
  </svg>
);
